<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <!-- 筛选的条件-->
          <a-row id="solo">
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单概况 :">
                <a-radio-group v-model="queryParam.orderStatus" button-style="solid" @change="handloadData(1)">
                  <a-radio-button :value="type.code" v-for="type in orderStatusArr" :key="type.code">
                    {{ type.text }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单类型 :">
                <a-radio-group v-model="queryParam.orderType" button-style="solid" @change="handloadData(1)">
                  <a-radio-button :value="type.code" v-for="type in orderTypeArr" :key="type.code">
                    {{ type.text }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未完成标记 :">
                <a-radio-group v-model="queryParam.unfinishTag" button-style="solid" @change="handloadData(1)">
                  <a-badge :count="type.count ? 0 : 0" v-for="type in noCompleteArr" :key="type.code">
                    <a-radio-button :value="type.code">
                      {{ type.text }}
                    </a-radio-button>
                  </a-badge>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单标记 :">
                <a-radio-group v-model="queryParam.orderTag" button-style="solid" @change="handloadData(1)">
                  <a-radio-button :value="type.code" v-for="type in orderMarkArr" :key="type.code">
                    {{ type.text }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20" class="mt-10">
            <a-col :xl="8" :xxl="6">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  show-search
                  placeholder="企业名称"
                  option-filter-prop="children"
                  style="width: 100%"
                  :filter-option="filterOption"
                  v-model="queryParam.enterpriseId"
                  @change="handleChange"
                >
                  <a-select-option :value="item.enterpriseId" v-for="item in dxEnterprise" :key="item.enterpriseId">
                    {{ item.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="订单信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model.trim="queryParam.orderNo" placeholder="订单号/原始单号" />
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="客户信息">
                <a-input v-model.trim="queryParam.clientName" placeholder="客户姓名/电话" />
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="快递单号">
                <a-input v-model.trim="queryParam.transportNo" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" >
                <a-form-item label="客户地址">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.provinceId" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                      >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.cityId" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.regionId" @change="countyonChange" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.address" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>

            <a-col :xl="8" :xxl="6">
              <a-form-item label="">
                <a-row>
                  <a-col :span="9">
                    <a-select v-model="queryParam.timeType" :allowClear="true">
                      <a-select-option v-for="type in timeTypeArr" :key="type.dictValue" :value="type.dictValue">{{
                        type.dictLabel
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="15">
                    <a-range-picker
                      allowClear
                      style="width:100%"
                      format="YYYY-MM-DD"
                      @change="onChangerangepicker"
                      v-decorator="[
                        'createTime',
                        {
                          initialValue: defaultTime
                        }
                      ]"
                    />
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="18" :style="{ textAlign: 'right' }">
              <!-- 查询功能待完善 只能查询公司名-->
              <a-button type="primary" htmlType="submit" @click="handloadData(1)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top:10px">
      <a-row class="mb-20">
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button class="ncreate" type="primary" style="margin-left: 8px" @click="exportEnt">导出订单</a-button>
        </a-col>
      </a-row>
      <!-- 表格内容-->
      <a-table
        :columns="columns"
        :rowClassName="setRowbg"
        :data-source="loadData"
        bordered
        :scroll="{ x: 1300 }"
        :pagination="false"
        :customRow="rowClick"
      >
        <!-- 操作插槽 -->
        <span slot="action" slot-scope="text, record">
          <a-tag color="blue" class="tag" @click="editorder(record, 1)">详情 </a-tag>
          <!-- <a-tag color="cyan" class="tag" @click="editorder(record, 2)">编辑 </a-tag>
          <a-tag
            color="orange"
            class="tag"
            v-if="record.reminderFlag == null && !record.signTime"
            @click="reminderOrder(record)"
            >催单
          </a-tag>
          <a-tag class="tag" color="red" @click="problemInitiate(record)">投诉 </a-tag> -->
        </span>
        <!-- 订单编号 -->
        <span slot="orderNo" slot-scope="text, record">
          <div class="blue">
            {{ record.orderNo }}
            <a title="复制客户信息"><a-icon type="copy" class="copy" @click="copy(record)"/></a>
          </div>
        </span>
        <!-- 最新过程 -->
        <span slot="latestProcess" slot-scope="text, record">
          <div class="blue">
            {{ record.latestProcess.split('*')[0] }}
          </div>
          <div class="blue">
            {{ record.latestProcess.split('*')[1] }}
          </div>
        </span>
        <!-- 客户信息 -->
        <span slot="clientName" slot-scope="text, record">
          <div>{{ record.clientName }} / {{ record.clientPhone }}</div>
          <div style="color:#999">
            {{ record.clientAddress }}
          </div>
          <div style="color:#999">
            {{ record.address }}
          </div>
        </span>
      </a-table>
      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList1"
        :showTotal="total => `总共 ${total} 条`"
        style="text-align: right; margin-top: 20px"
      />
    </a-card>
    <!-- 催单弹窗 -->
    <a-modal v-model="visible" title="催单申请" ok-text="确认" cancel-text="取消" @ok="reminder">
      <div class="flex_l mb-20">
        <div style="width:80px;text-align:right">订单编号：</div>
        <div>{{ orderNo }}</div>
      </div>
      <div class="flex_l flex-top">
        <div style="width:80px;text-align:right">添加备注：</div>
        <a-input
          class="flex-1"
          v-model="cuidanRemark"
          rows="4"
          placeholder="您确定催促预约或上门吗？"
          type="textarea"
        />
      </div>
    </a-modal>
    <!-- 投诉 -->
    <a-modal v-model="problemible" @ok="addproblem()" title="问题投诉" :width="600">
      <a-form :form="problemform">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="当前订单号">
              <a-input v-decorator="['orderNo']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题投诉">
              <a-radio-group @change="onChangeradio" :default-value="2">
                <!-- <a-radio :value="1"> 问题反馈 </a-radio> -->
                <a-radio :value="2"> 投诉 </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
              <a-input v-decorator="['handler']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉类型" v-if="value == 2">
              <a-select
                v-decorator="[
                  'matterCode',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择投诉类型!'
                      }
                    ]
                  }
                ]"
                @change="onChangecomplaint"
                :allowClear="true"
              >
                <a-select-option
                  v-for="type in complaintAuthority"
                  :key="type.matterCode"
                >{{ type.matterName }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉对象" v-if="value == 2">
              <a-select
                v-decorator="[
                  'complaintObject',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择投诉对象!'
                      }
                    ]
                  }
                ]"
                v-if="complaintObject"
                :allowClear="true"
                @change="handChange"
              >
                <a-select-option v-for="type in complaintObject" :key="type.code">{{ type.name }} </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="被投诉人" v-if="value == 2">
              <a-select
                v-decorator="[
                  'respondent',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择被投诉人!'
                      }
                    ]
                  }
                ]"
                v-if="complaintObject"
                :allowClear="true"
              >
                <a-select-option v-for="type in masterList" :key="type.userId">
                  {{ type.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉内容" v-if="value == 2">
              <a-textarea v-decorator="['complaintsContents']" />
            </a-form-item>
            <div v-else>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
                <a-select
                  v-decorator="[
                    'matterCode',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请选择问题类型!'
                        }
                      ]
                    }
                  ]"
                  :allowClear="true"
                  @change="onChangefeedback"
                >
                  <a-select-option v-for="type in feedbackAuthority" :key="type.code">{{ type.name }} </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                <a-textarea v-decorator="['contents']" />
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传图片">
              <a-upload
                name="file"
                :multiple="true"
                :action="currencyuploadUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :file-list="problemfileList"
                :headers="headers"
                @preview="handlePreview"
                @change="complainthandleChange"
              >
                <a-icon type="upload" />
                <div class="ant-upload-text">图片</div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  cuidan,
  getDxOrderList,
  getPendingMatterRoleUserList,
  noCompleteCount,
  getfinddictAll,
  getDxEnterpriseList, getselectAllProvince, getselectAreaName, getselectCityName
} from '@/api/order/orderList'
import {
  getComplaintAuthority,
  getFeedbackAuthority,
  getprocessor,
  getaddFeedback,
  getfeedbacklist,
  getaddComplaint
} from '@/api/order/editorder'
import moment from 'moment'
export default {
  name: 'EnterpriseBill',
  components: {
    // 注册弹框组件
    editOrderModel: () => import('./modules/editOrderModel'),
    cancelorder: () => import('./modules/cancelOrder')
  },
  data () {
    return {
      dxEnterprise: [], // 电信——企业名称
      query: {}, // 首页跳转的参数
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      // 订单状态
      orderStatusArr: [
        {
          text: '全部',
          code: ''
        },
        {
          text: '已下单',
          code: 'dispatchOrder'
        },
        {
          text: '已派单',
          code: 'receiveOrder'
        },
        {
          text: '已接单',
          code: 'reservationOrder'
        },
        {
          text: '已预约',
          code: 'installOrder'
        },
        {
          text: '已上门',
          code: 'doorOrder'
        },
        {
          text: '已安装',
          code: 'completeOrder'
        }
        // {
        //   text: '其他',
        //   code: 'other'
        // }
      ],
      // 订单类型
      orderTypeArr: [
        {
          text: '全部',
          code: ''
        },
        {
          text: '安装单',
          code: '安装单'
        },
        {
          text: '维修单',
          code: '维修单'
        },
        {
          text: '测量单',
          code: '测量单'
        },
        {
          text: '换锁单',
          code: '换锁单'
        },
        {
          text: '空跑单',
          code: '空跑单'
        },
        {
          text: '开锁单',
          code: '开锁单'
        },
        {
          text: '快递单',
          code: '快递单'
        },
        {
          text: '配件单',
          code: '配件单'
        }
      ],
      // 未完成标记
      noCompleteArr: [
        {
          text: '全部',
          code: ''
        },
        {
          text: '未预约',
          code: 1
        },
        // {
        //   text: '未上门',
        //   code: 2
        // },
        {
          text: '未安装',
          code: 3
        }
      ],
      // 订单标记
      orderMarkArr: [
        { text: '全部', code: '' },
        { text: '加急订单', code: 1 }
        // { text: '好评返现', code: 2 }
      ],
      // 查询时间分类
      timeTypeArr: [],
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {
        enterpriseId: '',
        orderStatus: '',
        orderType: '',
        unfinishTag: '',
        orderTag: '',
        orderNo: '',
        clientName: '',
        transportNo: '',
        orderTime: '',
        timeType: '',
        startTime: '',
        endTime: '',
        pageNum: '1',
        pageSize: '10'
      },
      loadData: [], // 列表数据
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      // 表头
      columns: [
        {
          title: '订单编号',
          // dataIndex: 'orderNo',
          align: 'center',
          scopedSlots: { customRender: 'orderNo' }
        },
        {
          title: '客户信息',
          scopedSlots: { customRender: 'clientName' },
          align: 'center'
        },
        {
          title: '订单概况',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '最新过程',
          // dataIndex: 'latestProcess',
          scopedSlots: { customRender: 'latestProcess' },
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: 'CTEI码',
          dataIndex: 'ctei',
          align: 'center'
        },
        {
          title: '序列号',
          dataIndex: 'serialNumber',
          align: 'center'
        },
        {
          title: '企业总金额',
          dataIndex: 'enterprisePrice',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          // fixed: 'right',
          // width: 200,
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ],
      visible: false, // 催单弹窗
      cuidanRemark: '',
      orderNo: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 投诉
      // 问题反馈model
      problemible: false,
      orderId: '',
      problemform: this.$form.createForm(this),
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=order',
      problemfileList: [],
      addproblemLoading: false,
      value: 2,
      feedbackAuthority: [],
      complaintAuthority: [],
      complaintObject: [
        {
          code: '',
          name: ''
        }
      ],
      masterList: [],
      tableCurrRowId: '',
      complaintfilelist: []
    }
  },
  watch: {
    $route (to, from) {
      if (to.name == 'qyOrderList' && Object.keys(to.params).length > 0) {
        this.init()
      }
    }
  },
  mounted () {
    // noCompleteCount().then(res => {
    //   this.$set(this.noCompleteArr[1], 'count', res.unsubscribeOrder)
    //   this.$set(this.noCompleteArr[2], 'count', res.unDoorOrder)
    //   this.$set(this.noCompleteArr[3], 'count', res.unInstallOrder)
    // })
    this.init()
    // 查询时间类型分类
    getfinddictAll({ dictTypes: 'time_type' }).then(res => {
      this.timeTypeArr = res.time_type
    })
    // 省
    getselectAllProvince().then(res => {
      if (res.code === 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    // 电信——企业名称
    getDxEnterpriseList({
      type: 0
    }).then(res => {
      this.dxEnterprise = res.data
    })
  },
  methods: {
    init () {
      this.empty()
      this.query = this.$route.params
      if (this.query.orderStatus) {
        this.queryParam.timeType = 'create_time'
        this.queryParam.startTime = this.query.startTime
        this.queryParam.endTime = this.query.endTime
        this.queryParam.orderStatus = this.query.orderStatus == 'orderTotal' ? '' : this.query.orderStatus
        this.form.setFieldsValue({
          createTime: [moment(this.queryParam.startTime), moment(this.queryParam.endTime)]
        })
      } else if (this.query.unfinishTag) {
        this.queryParam.timeType = 'create_time'
        this.queryParam.startTime = this.query.startTime
        this.queryParam.endTime = this.query.endTime
        this.queryParam.unfinishTag = this.query.unfinishTag * 1
        this.form.setFieldsValue({
          createTime: [moment(this.queryParam.startTime), moment(this.queryParam.endTime)]
        })
      }
      this.handloadData(1)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 市
    getselect (e) {
      this.selectCityName = []
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    countyonChange (val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.countyId, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.countyId, '')
      }
    },
    // 区
    getprovinceName (e) {
      this.selectAreaName = []
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 1、订单列表导出
    moment,
    exportEnt () {
      this.$axios({
        method: 'get',
        url: '/api/order/merchantOrder/telecomOrderListExport',
        params: this.queryParam,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
        } else {
          var str =
            process.env.VUE_APP_API_BASE_URL + '/order/merchantOrder/telecomOrderListExport?pageNum=1&pageSize=10'
          for (const i in this.queryParam) {
            if (this.queryParam[i] != undefined) {
              str = str + '&' + i + '=' + this.queryParam[i]
            }
          }
          str = str + '&token=' + this.headers.token
          window.open(str)
        }
      })
    },
    // 2、下单时间
    onChangerangepicker (date, dateString) {
      console.log(dateString)
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    // 3、获取订单列表
    handloadData (page) {
      if (page == 1) {
        this.queryParam.pageNum = 1
        this.current = 1
      }
      getDxOrderList(this.queryParam).then(res => {
        this.loadData = res.rows
        this.total = res.total
      })
    },
    // 4、清空查询条件
    empty () {
      this.queryParam = {
        orderStatus: '',
        enterpriseId: '',
        orderType: '',
        unfinishTag: '',
        orderTag: '',
        orderNo: '',
        clientName: '',
        transportNo: '',
        orderTime: '',
        timeType: '',
        startTime: '',
        endTime: ''
      }
      this.form.setFieldsValue({
        createTime: []
      })
    },
    // 复制
    copy (val) {
      const url =
        `订单号：` +
        val.orderNo +
        '\n' +
        `订单类型：` +
        val.orderType +
        '\n' +
        `型号：` +
        val.modelName +
        '\n' +
        `客户姓名：` +
        val.clientName +
        '\n' +
        `客户联系方式：` +
        val.clientPhone +
        '\n' +
        `客户地址：` +
        val.clientAddress +
        val.address
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    // 分页
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },
    getdataList1 (value) {
      this.current = value
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.handloadData()
    },
    // 订单详情
    editorder (record, type) {
      this.$router.push({
        path: '/order/dxOrderDetail',
        query: {
          orderId: record.orderId,
          type
        }
      })
    },
    // 催单
    reminderOrder (record) {
      this.$nextTick(() => {
        this.visible = true
        this.orderId = record.orderId
        this.orderNo = record.orderNo
      })
    },
    reminder () {
      cuidan({
        orderId: this.orderId,
        orderNo: this.orderNo,
        reminderRemark: this.cuidanRemark
      }).then(res => {
        if (res.code == 0) {
          this.$message.success('催单成功')
          this.visible = false
          this.cuidanRemark = ''
          this.handloadData()
        } else {
          this.$message.error(res.msg)
          this.visible = false
          this.cuidanRemark = ''
        }
      })
    },
    // 投诉
    problemInitiate (record) {
      this.orderId = record.orderId
      this.problemform.resetFields()
      this.problemible = true
      this.addproblemLoading = false
      this.problemfileList = []
      this.$nextTick(() => {
        this.problemform.setFieldsValue({ orderNo: record.orderNo, orderId: record.orderId })
      })
      getComplaintAuthority().then(res => {
        if (res.code === 0) {
          this.complaintAuthority = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addproblem () {
      this.addproblemLoading = true
      this.userId = this.$store.getters.userId
      this.problemform.validateFields((err, values) => {
        values.picUrlList = this.complaintfilelist
        if (!err) {
          this.addproblemLoading = false
          if (this.value == 1) {
            values.initiator = this.userId
            getaddFeedback(values).then(res => {
              if (res.code === 0) {
                this.problemible = false
                this.$emit('ok')
                // this.updateFeedbacklist()

                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            values.complainant = this.userId

            this.problemible = false
            getaddComplaint(values).then(res => {
              if (res.code === 0) {
                this.$emit('ok')
                // this.updateCompalanitlist()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    updateFeedbacklist () {
      getfeedbacklist({
        orderId: this.reslist.orderId
      }).then(res => {
        if (res.code === 0) {
          this.feedbacklist.feedbackList = res.data.feedbackList
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // onChangeradio(e) {
    //   this.value = e.target.value
    //   this.problemform.setFieldsValue({
    //     handler: ''
    //   })
    //   if (this.value == 1) {
    //     getFeedbackAuthority().then(res => {
    //       if (res.code === 0) {
    //         // console.log(res)
    //         this.feedbackAuthority = res.data
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   } else {
    //     getComplaintAuthority().then(res => {
    //       if (res.code === 0) {
    //         this.complaintAuthority = res.data
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   }
    // },
    // 被投诉人
    handChange (e) {
      const matterCode = this.problemform.getFieldValue('matterCode')
      this.problemform.setFieldsValue({
        respondent: ''
      })

      getPendingMatterRoleUserList({
        complaintObject: e,
        orderId: this.orderId
      }).then(res => {
        this.masterList = res.data
      })
    },
    onChangefeedback (e) {
      const obj = {}
      obj.relationType = 'orderId'
      obj.relationId = this.problemform.getFieldValue('orderId')
      obj.matterCode = e
      getprocessor(obj).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.problemform.setFieldsValue({
            handler: res.rows
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    complainthandleChange (info) {
      console.log(888888888888, info)
      this.$nextTick(() => {
        this.problemfileList = info.fileList
      })
      if (info.file.status === 'removed') {
        if (info.file.response.code == 0) {
          const index = this.complaintfilelist.indexOf(info.file.response.url)
          this.complaintfilelist.splice(index, 1)
        }
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 0) {
          let list = {}
          list.url = info.file.response.url
          list.uid = info.fileList[0].uid
          list.name = info.fileList[0].name
          list = JSON.stringify(list)
          this.complaintfilelist.push(list)
          console.log(this.complaintfilelist)
        }
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    handlePreview (file) {
      console.log(file)
      if (!file.url && !file.preview) {
        file.preview = file.thumbUrl
      } else {
        file.url = file.url
      }
      this.previewImage = file.url || file.preview
      // console.log(this.previewImage)
      this.previewVisible = true
    },
    onChangecomplaint (e) {
      const obj = {}
      obj.relationType = 'orderId'
      obj.relationId = this.problemform.getFieldValue('orderId')
      obj.matterCode = e
      getprocessor(obj).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.problemform.setFieldsValue({
            handler: res.rows
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      this.complaintAuthority.forEach(item => {
        if (item.matterCode == e) {
          this.complaintObject = item.complaintObject
          console.log(this.complaintObject)
        }
      })
      this.problemform.setFieldsValue({
        complaintObject: '',
        respondent: ''
      })
    },
    // 设置每行的颜色
    setRowbg (record) {
      return record.id === this.tableCurrRowId ? 'bg-pink' : null
    },
    // 点击每一行添加变量
    rowClick (record) {
      return {
        on: {
          click: () => {
            // 点击改行时要做的事情
            this.tableCurrRowId = this.tableCurrRowId == record.id ? '' : record.id
          }
        }
      }
    }
  }
}
</script>

<style scoped>
/deep/ #solo .ant-form-item-label {
  width: 100px !important;
}
/deep/ #solo .ant-form-item {
  margin-bottom: 14px !important;
}
/deep/ #solo .ant-radio-button-wrapper {
  height: 28px !important;
  line-height: 26px !important;
}
/deep/ .clickRowStyle {
  background: #ffbcb7;
}
/deep/ .clickRowStyle3 {
  background: #f9ff9f;
}
/deep/ .clickRowStyle4 {
  background: #ffa07a;
}
/deep/ .ant-calendar-picker {
  width: 276px;
}
/deep/ .notshow {
  display: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}

/*</a-form-item>*/
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
/deep/ p {
  margin-top: 0;
  margin-bottom: 0em;
}
/deep/ .ant-pagination-options-quick-jumper input {
  width: 80px;
}
/deep/ .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: #fff;
}
/deep/ .ant-radio-button-wrapper {
  border: none;
  border-radius: 4px;
}
/* /deep/ .ant-table-thead > tr > th {
  background: royalblue;
  color: #fff;
} */
/deep/ .bg-pink {
  background-color: rgb(255, 212, 147);
}
.tag {
  font-size: 14px;
  height: 24px;
  line-height: 24px;
}
.blue {
  font-size: 16px;
}
</style>
